<template>
  <div class="my-6">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-x-3">
        <p class="text-black-10 text-base lg:text-lg">Beneficiaries</p>
        <h4 class="text-fg-default lg:text-base text-xs font-semibold my-1.5">
          {{ bulkPayoutDetails.count || 0 }}
        </h4>
      </div>
      <div class="md:flex items-center gap-x-3">
        <div
          class="grid grid-cols-2 lg:flex lg:items-center lg:justify-between gap-x-2"
        >
          <!-- search functionality not working yet -->
          <div class="md:pb-1 pb-0">
            <!-- <el-form>
              <el-form-item class="lg:w-302px">
                <el-input
                  class="w-full"
                  v-model="search"
                  @search="searchResult"
                  placeholder="Search"
                >
                  <i
                    slot="prefix"
                    :size="40"
                    class="el-input__icon el-icon-search"
                  ></i>
                </el-input>
              </el-form-item>
            </el-form> -->
          </div>
        </div>
        <!-- <el-button
          @click="goToNewBulkPayout"
          class="px-4 w-2/4 lg:w-full lg:py-4 py-2.5 flex items-center justify-center gap-x-2 bg-primary text-white shadow-sm rounded-lg mb-6 font-light"
        >
           <div class="flex items-center gap-x-2">
            <upload-icon />
            <span class="text-xs lg:text-base">Export CSV</span>
          </div>
        </el-button> -->
      </div>
    </div>
    <div>
      <div class="mt-6" v-if="isLoading">
        <spinner />
      </div>
      <div v-else>
        <el-table
          class="relative cursor-pointer font-normal text-root-2 text-xs lg:text-sm"
          index
          :data="tableData"
          style="width: 100%"
          max-height="500"
          @row-click="handleRowClick"
          row-class-name="table_row"
        >
          <el-table-column class="w-full" type="index" :width="indexColWidth">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 mx-1 lg:px-2 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  S/N
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Beneficiary
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <div @click="handleSort('name')">
                    <sort-icon :sortDirection="sortDirection.name" />
                  </div>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                class="flex items-center justify-start font-light text-xs md:text-sm"
              >
                <span class="truncate" style="word-break: normal">{{
                  scope.row.name || scope.row.details.accountName || '--'
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Bank Name
                </p>
                <!-- <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip> -->
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-medium flex text-sm md:text-sm justify-start">
                <div class="pl-2 font-light text-xs md:text-sm">
                  {{ displayBankName(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Bank Code
                </p>
                <!-- <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip> -->
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-medium flex text-sm md:text-sm justify-start">
                <div class="pl-2 font-light text-xs md:text-sm">
                  {{ displayBankCode(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Account Number
                </p>
                <!-- <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip> -->
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-medium flex text-sm md:text-sm justify-start">
                <div class="pl-2 font-light text-xs md:text-sm">
                  {{ displayAccountNumber(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-center py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Remarks
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-medium flex text-sm md:text-sm">
                <div class="pl-2 font-light text-xs md:text-sm">
                  {{ scope.row.remarks }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column class="w-full" :width="columnWidth" align="center">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Status
                </p>
                <!-- <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip> -->
              </div>
            </template>
            <template slot-scope="scope">
              <div>
                <span
                  class="inline-block text-xs capitalize py-1 px-3 rounded-full"
                  :class="statusClass(scope.row.status)"
                >
                  {{ formatServerName(scope.row.status) }}
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- intermediary bank details starts here -->
          <template v-if="hasIntermediaryBankDetails">
            <el-table-column class="w-full" :width="columnWidth" align="center">
              <template slot="header">
                <div
                  class="flex items-center justify-center py-2 px-2 lg:px-5 font-medium"
                >
                  <p
                    style="word-break: normal"
                    class="text-root-2 text-xs lg:text-sm"
                  >
                    Intermediary Bank Name
                  </p>
                </div>
              </template>
              <template slot-scope="scope">
                <div
                  class="flex items-center justify-center text-xs md:text-sm capitalize"
                >
                  {{ displayIntermediaryBank(scope.row) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column class="w-full" :width="columnWidth" align="center">
              <template slot="header">
                <div
                  class="flex items-center justify-center py-2 px-2 lg:px-5 font-medium"
                >
                  <p
                    style="word-break: normal"
                    class="text-root-2 text-xs lg:text-sm"
                  >
                    Swift Code
                  </p>
                </div>
              </template>
              <template slot-scope="scope">
                <div
                  class="flex items-center justify-center text-xs md:text-sm capitalize"
                >
                  {{ displaySwiftCode(scope.row) }}
                </div>
              </template>
            </el-table-column>
          </template>
          <!-- intermediary bank details ends here -->
          <el-table-column class="w-full" :width="columnWidth" align="center">
            <template slot="header">
              <div
                class="flex items-center justify-start py-2 px-2 my-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Amount
                </p>
                <div @click="handleSort('amount')">
                  <el-tooltip content="Sort" placement="top" effect="light">
                    <sort-icon :sort-direction="sortDirection.amount" />
                  </el-tooltip>
                </div>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="flex items-center justify-start ml-4 gap-x-1">
                <span class="text-xs md:text-sm capitalize">{{
                  parseMoneyAll(
                    scope.row.amount.amount,
                    scope.row.amount.currency
                  )
                }}</span>
                <div class="ml-5px">
                  <arrow-right-icon />
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <transaction-empty-state v-if="!isLoading && noTransactions">
        <h3 class="font-medium text-lg lg:text-xl my-1.5">No Beneficiaries.</h3>
        <p class="font-light text-xs lg:text-sm md:text-base">
          Your beneficiaries will be listed here.
        </p>
      </transaction-empty-state>

      <div class="p-6 grid grid-cols-1 md:justify-items-end">
        <!--Pagination-->
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="page.size"
          @next-click="next"
          @prev-click="previous"
          background
          layout="prev, pager, next"
          :total="page.totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- drawers -->
    <beneficiary-drawer
      v-if="showBeneficiaryDetails"
      :beneficiary-details="beneficiaryDetails"
      :showDrawer="showBeneficiaryDetails"
      @closeDrawer="closeDrawer"
      @refresh="refreshHandler"
    />
  </div>
</template>

<script>
import statusClass from '@/mixins/app.js'
import getPaymentLinks from '@/mixins/paymentLink.js'
import breakpoints from '@/utils/breakpoints.js'
import { sortHandlerMixin } from '@/mixins/useSort.js'

import {
  FormatServerName,
  DaysAgo,
  AddComma,
  ParseMoneyAll
} from '@/utils/helpers.js'
export default {
  mixins: [statusClass, getPaymentLinks, sortHandlerMixin],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    isPaginate: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    tableType: {
      type: String,
      default: () => '',
      required: true
    },
    page: {
      type: Object,
      default: () => {},
      required: true
    },
    isLoading: { type: Boolean, default: false }
  },
  components: {
    BeneficiaryDrawer: () =>
      import('@/components/v2/bulkPayout/drawers/index.vue'),
    SortIcon: () => import('@/assets/v2/icons/SortIcon.vue'),
    TransactionEmptyState: () =>
      import('@/components/v2/bulkPayout/layouts/TransactionEmptyState.vue'),
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    Spinner: () => import('@/components/v2/app/Spinner.vue')
  },
  data () {
    return {
      isCopyOnTable: false,
      showBeneficiaryDetails: false,
      beneficiaryDetails: {},
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: '',
        sort_direction_desc: true,
        sort_by: 'updated_at'
      },
      showCreatePaymentLinkDrawer: false,
      showSuccessfulPaymentLinkDialog: false,
      showTableFilter: false,
      mode: '',
      search: ''
    }
  },
  methods: {
    refreshHandler () {
      this.$emit('refresh')
    },
    closeDrawer () {
      this.showBeneficiaryDetails = false
    },
    goToNewBulkPayout () {
      this.$store.dispatch('bulkPayout/setActiveComponent', 'bulk-payout-form')
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    displayTimeDate (row) {
      const timeToPick =
        row.status === 'completed' ? row.completedAt : row.createdAt
      return this.tooltipDateContent(timeToPick)
    },
    addComma (val) {
      return AddComma(val.toString())
    },
    // sortHandler () {
    //   console.log('logger two')
    //   this.sortDirection = this.sortDirection === 'up' ? 'down' : 'up'
    //   console.log('logger two sorted')
    //   this.$emit('sort')
    // },
    daysAgo (date) {
      return DaysAgo(date)
    },
    // search box not functional yet
    searchResult (search) {
      if (this.search !== '' && this.search) {
        search = this.payload.filter((tableData) => {
          return tableData.toUpperCase().includes(this.search.toUpperCase())
        })
      }
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    next (val) {
      this.$emit('handleCurrentChange', { page: val, type: this.tableType })
    },
    previous (val) {
      this.$emit('handleCurrentChange', { page: val, type: this.tableType })
    },
    handleCurrentChange (val) {
      this.resetSortDirection()
      this.$emit('handleCurrentChange', { page: val, type: this.tableType })
    },
    closeDialog (dialog) {
      this[dialog] = false
    },
    handleRowClick (row) {
      if (!this.isCopyOnTable) {
        this.beneficiaryDetails = row
        this.showBeneficiaryDetails = true
      }
      this.isCopyOnTable = false
    },
    onCopy: function (e) {
      this.isCopyOnTable = true
      this.$notify.success({
        title: 'Bulk ID copied successfully!'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    displayBankName (row) {
      return (
        row.details?.bankDetails?.bankName || row.details?.bankName || 'N/A'
      )
    },
    displaySwiftCode (row) {
      return (
        row.details.intermediaryBank?.swiftCode ||
        row.details.swiftCode ||
        'N/A'
      )
    },
    displayIntermediaryBank (row) {
      return (
        row.details.intermediaryBank?.bankName || row.details.bankName || 'N/A'
      )
    },
    displayAccountNumber (row) {
      return (
        row.details.accountNumber ||
        row.details.bankDetails?.accountNumber ||
        'N/A'
      )
    },
    displayBankCode (row) {
      return row.details.bankCode || row.details?.bankDetails?.bankCode || '--'
    }
  },
  computed: {
    bulkPayoutDetails () {
      return this.$store.state.bulkPayout.currentBulkPayoutDetails.items
    },
    hasIntermediaryBankDetails () {
      return this.$store.state.bulkPayout.currentBulkPayoutDetails.attributes[0]
        .details?.intermediaryBank?.swiftCode
    },
    isOngoing () {
      return this.tableType === 'ongoing'
    },
    isHistory () {
      return this.tableType === 'history'
    },
    noTransactions () {
      return !this.tableData.length > 0
    },
    columnWidth () {
      return breakpoints.lgAndUp ? 'auto' : breakpoints.mdAndUp ? '220' : '170'
    },
    indexColWidth () {
      return breakpoints.lgAndUp ? '100' : breakpoints.mdAndUp ? '150' : '100'
    }
  }
}
</script>

<style scoped>
>>> .el-table {
  background-color: #f7f7f7;
  border-collapse: separate;
  padding: 0 10px;
}
>>> .el-table th {
  background: #f7f7f7;
  padding-bottom: 20px;
}
>>> .el-table table {
  border-spacing: 0 16px;
}
>>> .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: white !important;
}
>>> li.number.active {
  background-color: var(--color-primary) !important;
  border: none !important;
  color: white !important;
  border-radius: 7.53065px !important;
}
>>> li.number {
  border: none !important;
  font-weight: 500;
  font-size: 12px;
  color: var(--text-2);
  background: transparent !important;
  /* color: var(--color-primary) !important ; */
}
>>> li.number:hover {
  border: 0.941331px solid var(--color-primary) !important;
  border-radius: 7.53065px !important;
  color: var(--text-2) !important;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  background: var(--background-10);
}
>>> .el-table td {
  border-bottom: none !important;
  background: white;
  padding: 18px 0;
}
>>> .el-table tr {
  padding: 10px 0;
}
>>> .el-table td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding-left: 20px;
}
>>> .el-table td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
>>> .el-tooltip__popper.is-dark,
>>> .el-tooltip__popper.is-light,
>>> .el-tooltip__popper {
  background: white !important;
}

>>> .el-tooltip__popper.is-light {
  background: white !important;
}
</style>
